function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Line_69",
  x: 24.879,
  y: 12.879,
  width: 18.242,
  height: 18.242,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1577",
  "data-name": "Group 1577",
  transform: "translate(16276 15894)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1535",
  "data-name": "Group 1535",
  transform: "translate(-17771 -16106)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 1495, 212)",
  filter: "url(#Line_69)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_69-2",
  "data-name": "Line 69",
  x2: 8,
  y2: 8,
  transform: "translate(29 17)",
  fill: "none",
  stroke: "#e94e4e",
  strokeLinecap: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_828",
  "data-name": "Path 828",
  d: "M0,8,8,0",
  transform: "translate(1524 229)",
  fill: "none",
  stroke: "#e94e4e",
  strokeLinecap: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1534",
  "data-name": "Group 1534",
  transform: "translate(-17778 -16107)",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("text", {
  id: "F-Gas",
  transform: "translate(1502 226)",
  fill: "#333",
  fontSize: 12,
  fontFamily: "Poppins-Bold, Poppins",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "F-Gas")), /*#__PURE__*/React.createElement("text", {
  id: "Certified",
  transform: "translate(1502 233)",
  fill: "#333",
  fontSize: 7,
  fontFamily: "Poppins-Regular, Poppins"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Certified"))));

var SvgNoCert = function SvgNoCert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43.121,
    height: 31.121,
    viewBox: "0 0 43.121 31.121",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoCert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noCert.ef83234a.svg";
export { ForwardRef as ReactComponent };